module.exports = __webpack_public_path__ + "static/media/text_editor.11a7d5e5.png";